<template>
  <section class="sectionBox">
    <!-- 左侧导航栏 -->
    <div class="left_box">
      <el-menu default-active="1" class="el-menu-vertical-demo" background-color="#014f86"
        text-color="#fff" unique-opened active-text-color="#0074ff" @select="changeType">
        <el-menu-item index="1">民政救助</el-menu-item>
        <el-menu-item index="2">退役军人事务</el-menu-item>
        <el-menu-item index="3">人社保障</el-menu-item>
        <el-menu-item index="4">残疾人保障</el-menu-item>
        <el-menu-item index="5">卫生健康</el-menu-item>
        <el-menu-item index="6">公租房申请</el-menu-item>
        <el-menu-item index="7">社区建设</el-menu-item>
      </el-menu>
    </div>
    <!-- 右侧内容区域 -->
    <div class="right_box">
      <!-- 面包屑导航 -->
      <div v-show="pageName!=''" class="mianbao">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/communityServices' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{pageName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="right_box_main">
        <div class="card-box">
        <!-- 右边卡片 -->
          <div class="card-4" style="width: 100%;">
            <el-card :body-style="{ padding: '16px' }">
              <div class="fisthang">
                <el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
                    <el-form-item label="标题:">
                    <el-input v-model="searchlist.title" placeholder="请输入关键字搜索" style="width:130px"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="发布状态:">
                    <el-select size="mini" v-model="searchlist.status" placeholder="--状态--" style="width:130px" >
                        <el-option label="1" value="1">正常</el-option>
                        <el-option label="0" value="0">下架</el-option>
                    </el-select>
                    </el-form-item> -->
                    <el-form-item>
                    <el-button type="primary" @click="searchlistdata">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                    <el-button type="info" @click="searchlistReset">重置</el-button>
                    </el-form-item>
                    <el-form-item></el-form-item>
                </el-form>
              </div>
              <div class="three">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="showDialog({},'add')">新增</el-button>
                <!-- <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteRows">删除</el-button> -->
              </div>
              <!-- 表格盒子 -->
              <div class="table_card">
                <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                  border align="center" current-row-key highlight-current-row>
                  <el-table-column align="center" prop="title" label="标题"></el-table-column>
                  <el-table-column align="center" prop="content" label="内容"></el-table-column>
                    <!-- <el-table-column align="center" prop="status" label="发布状态" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.processingTime <= 300" type="success">正常</el-tag>
                        <el-tag v-else type="danger">下架</el-tag>
                    </template>
                    </el-table-column> -->
                  <el-table-column align="center" label="操作" width="160" fixed="right">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                        <button class="tabBtn el-icon-edit-outline tabBtn-edit" @click="showDialog(scope.row,'edit')"></button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                        <button class="tabBtn el-icon-delete tabBtn-delete" @click="showdeletepanduan(scope.row.id)"></button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :page-size="pageConfig.pageSize" layout="total, prev, pager, next, jumper"
                    @current-change="handleCurrentChange" :total="pageConfig.total" ></el-pagination>
              </div>
            </el-card>
          </div>
        </div>
        <!-- 弹出框编辑 -->
        <el-dialog class="newDialog" center title="新增" :visible.sync="addDialog.off" width="800px" >
          <el-form label-position="right" size="mini" label-width="120px" :model="addDialog.form">
            <el-form-item label="标题：">
              <el-input placeholder="请输入标题" v-model="addDialog.form.title"></el-input>
            </el-form-item>
            <!-- <el-form-item label="内容：" prop="content" style="margin-top: 10px;margin-bottom: 120px">
              <quillEditor v-model="addDialog.form.content" :options="editorOption" style="height:200px"></quillEditor>
            </el-form-item> -->
            <el-form-item label="内容：" prop="content" >
              <el-input type="textarea" :autosize="{ minRows:10, maxRows: 30}"
                placeholder="请输入内容" v-model="addDialog.form.content">
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="立即发布：">
              <el-radio-group v-model="addDialog.form.enable">
                <el-radio label="0">发布</el-radio>
                <el-radio label="1">下架</el-radio>
              </el-radio-group>
            </el-form-item> -->
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" style="margin: 0 30px" @click="saveData">确定</el-button>
            <el-button type="info" size="small" @click="addDialog.off = false">取消</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </section>
</template>
<script>
import request from "../../utils/request.js"
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import editor_option from '../../utils/editorOption.js'
export default {
  components: {quillEditor},
  data() {
    return {
      searchlist: {
        activeType: '1'
      },
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      addDialog: {
        form: {},
        off: false,
        title: "",
        type: ""
      },
      // 富文本配置
      editorOption: editor_option.editorOption,
      pageName: '民政救助'
    };
  },
  methods: {
    changeType (val){
      this.searchlist.activeType = val
      if(val == '1'){
        this.pageName = '民政救助'
      }else if(val == '2'){
        this.pageName = '退役军人事务'
      }else if(val == '3'){
        this.pageName = '人社保障'
      }else if(val == '4'){
        this.pageName = '残疾人保障'
      }else if(val == '5'){
        this.pageName = '卫生健康'
      }else if(val == '6'){
        this.pageName = '公租房申请'
      }else if(val == '7'){
        this.pageName = '社区建设'
      }else{
        this.pageName = '其它'
      }
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //条件查询
    searchlistdata (){
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset (){
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange (val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas () {
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      let params = JSON.stringify(this.searchlist)
      console.log(params)
    //   var res = await request({
    //     url: "/admin/civicEducation/info/listCivicEducation",
    //     method: "POST",
    //     data: params
    //   })
    //   if (res.code == 200) {
    //     if(res.content != null){
    //       this.pageConfig.total = res.content.count;
    //       this.tableData = res.content.list
    //     }else{
    //       this.pageConfig.total = 0;
    //       this.tableData = []
    //     }
    //   }else{
    //     console.log(res)
    //     this.$message({
    //       message: "数据加载异常",
    //       type: "error"
    //     });
    //   }
      let title = this.pageName + '-信息标题'
      let content = "1.服务对象：需要审核家庭经济状况的申请户\n\r2.服务对象需满足的条件：根据《合肥市社会救助申请家庭经济状况核算办法》文件核算家庭收入"
      let createDate = '2020-03-31 12:11:11'
      this.tableData = []
      for(let i=1; i<10; i++){
        this.tableData.push({id:i,title:title,content:content,createDate:createDate})
      }
      this.pageConfig.total = 10
    },
    
    //新增
    async showDialog(row,flag) {
      this.addDialog.type = flag
      this.addDialog.off=true
      if(row.id && flag=='edit'){
        this.addDialog.title = '编辑'
        this.addDialog.form = row
        // let params = JSON.stringify({id:row.id});
        // var res = await request({
        //   url: "/admin/civicEducation/info/getCivicEducation",
        //   method: "POST",
        //   data: params
        // })
        // // console.log(res)
        // if (res.code == 200) {
        //   this.addDialog.form = res.content
        //   this.addDialog.form.channel = []
        //   if(res.content.channel != ''){
        //     let arr = res.content.channel.split('|')
        //     arr.forEach(val => {
        //       if(val != ''){
        //         this.addDialog.form.channel.push(val)
        //       }
        //     })
        //   }
        //   this.addDialog.off=true
        // }else{
        //   console.log(res.code + '：' +res.message)
        //   this.$message({
        //     message: "编辑项加载异常",
        //     type: "error"
        //   })
        //   this.addDialog.off=false
        // }
      }else{
        this.addDialog.title = '新增'
        this.addDialog.form = {}
      }
      
    },
    //弹框保存
    async saveData() {
      let params = JSON.stringify(this.addDialog.form);
      if (params == "{}") {
        this.$message({
          message: "保存数据为空",
          type: "error"
        });
        return false
      }
      console.log(params)
      this.$message({
          message: '接口尚未调通',
          type: "success"
        });
        return

      let url = '/admin/smallArea/info/updateEquipment'
      if(this.addDialog.type == 'add'){
        url = '/admin/civicEducation/info/insertCivicEducation'
      }
      var res = await request({
        url: url,
        method: "POST",
        data: params
      });
      if (res.code == 200) {
        this.$message({
          message: this.addDialog.title + '成功',
          type: "success"
        });
        this.addDialog.off = false
        this.pageConfig.pageNo = 1
        this.getPageDatas()
      }else{
        console.log(res)
        this.$message({
            message: this.addDialog.title + "失败：" + res.message,
            type: "error"
          });
      }
    },
    // 取消
    clearadddata() {
      this.addDialog.off = false
    },
      //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
          let params = JSON.stringify({id:id})
          var res = await request({
            url: "/admin/civicEducation/info/deleteCivicEducation",
            method: "POST",
            data: params
          });
          if (res.code == 200) {
            this.$message({
              message: '删除成功',
              type: "success"
            });
            this.addDialog.off = false
            this.pageConfig.pageNo = 1
            this.getPageDatas()
          }else{
            console.log(res)
            this.$message({
                message: "删除失败：" + res.message,
                type: "error"
              });
          }
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
  },
  mounted() {
    // 初始化数据
    this.getPageDatas()
  }
};
</script>
